import React, { useState } from "react";

import ViewLessonModal from "./ViewLessonModal";
import useQueryViewLessonModal from "./hooks/useGetViewLessonModalData";

import { CancelLessonModal } from "@hubcapp/components";
import {
  EditLessonFormSchema,
  ViewLessonModalStateProviderProps,
} from "./types";
import { useTealium } from "@hubcapp/context";
import useMutationEditLesson from "@hubcapp/components/Calendar/components/Modals/ViewLessonModal/hooks/useMutationEditLesson";

const ViewLessonModalStateProvider: React.FC<ViewLessonModalStateProviderProps> = ({
  closeViewLessonModal,
  lessonId,
  open,
  refetchCalendarData,
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { data, loading } = useQueryViewLessonModal(lessonId);
  const { trackEvent } = useTealium();

  const [
    editLessonHandler,
    { loading: loadingEditLesson },
  ] = useMutationEditLesson();

  const openCancelModal = () => {
    trackEvent({
      eventCategory: "Calendar - View Lesson",
      eventAction: "Button Click",
      eventLabel: "Delete Lesson",
    });
    setShowCancelModal(true);
  };

  const closeCancelModal = () => {
    setShowCancelModal(false);
  };

  const handleCancelViewLessonModal = () => {
    trackEvent({
      eventCategory: "Calendar - View Lesson",
      eventAction: "Button Click",
      eventLabel: "Cancel Confirm",
    });
    setShowCancelModal(false);
  };

  const updateLessonHandler = (data: EditLessonFormSchema) => {
    editLessonHandler({
      variables: {
        input: data,
      },
    }).then(() => {
      closeViewLessonModal();
      refetchCalendarData();
    });
  };

  if (loading) return null;

  return (
    <>
      {showCancelModal && data?.lesson ? (
        <CancelLessonModal
          lessonId={lessonId}
          lessonStartDateTime={data.lesson.startDateTime}
          lessonPrePaid={data.lesson.paid}
          open={showCancelModal}
          onCancelClicked={handleCancelViewLessonModal}
          onConfirmClicked={() => {
            closeCancelModal();
            closeViewLessonModal();
          }}
        />
      ) : (
        <ViewLessonModal
          cancelLesson={openCancelModal}
          closeViewLessonModal={closeViewLessonModal}
          lesson={data?.lesson}
          loading={loading || loadingEditLesson}
          open={open}
          onSubmit={updateLessonHandler}
        />
      )}
    </>
  );
};

export default ViewLessonModalStateProvider;
